module.exports = __webpack_public_path__ + "img/gate-rail-horizontal-shadow.55159398.png";